<template>
  <div>
        <div id="mymap" ref="mm" :style="{ height: height + 'px'}"></div>
  </div>
</template>

<script>
import { editor_map } from "@/main";

export default {
  props: ["map", "height"],

  async mounted() {
    await this.map.init(this.$refs.mm);
    // Sync initialized state back to global stub
    Object.assign(editor_map, this.map);
  },
  methods: {
  }
}
</script>
<style scoped>
  #mymap{
    z-index: 1;
  }
</style>
